import { get, post, patch } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/notifications`;
export const list        = (wsId, params = {}) => { const q = Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : ''; return get(`${base(wsId)}${q}`); };
export const getCount    = (wsId)              => get(`${base(wsId)}/count`);
export const create      = (wsId, body)        => post(base(wsId), body);
export const markRead    = (wsId, notifId)     => patch(`${base(wsId)}/${notifId}/read`, {});
export const markAllRead = (wsId)              => patch(`${base(wsId)}/read-all`, {});
